import UsersManager from "../managers/UsersManager";
import {Constants} from "../constants/Constants";

export default class RequestUtils {
    public static getHeaders = () => {
        let loggedInUser = JSON.parse(UsersManager.getLoggedInUser() as string);
        return {
            [Constants.API_KEY]: loggedInUser.apiKey
        };
    }
}